import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../../actions/actionCreators";
import MaterialModal from "../../MaterialModal";
import withModal from "../../withModal";
import { Paper, Table, TableBody, TableRow, TableCell } from "@material-ui/core";

const jobDetailsModalProps = {
    modalProps: PropTypes.shape({
        requestInfo: PropTypes.any,
        inputFiles: PropTypes.any,
        jobInfo: PropTypes.string,
        cancel: PropTypes.func.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type JobDetailsModalProps = PropTypes.InferProps<typeof jobDetailsModalProps>;

const JobDetailsModal: React.FC<JobDetailsModalProps> = ({ modalProps, isOpen }: JobDetailsModalProps) => {
    const dispatch = useDispatch();
    const [fileList, setFileList] = useState<Array<string>>([]);

    const hide = () => {
        dispatch(hideModal("FLOW_CONTROL_JOB_DETAILS"));
        modalProps.cancel();
    };

    useEffect(() => {
        if (typeof modalProps.inputFiles != "undefined" && modalProps.inputFiles != "") {
            setFileList(modalProps.inputFiles?.toString().split(","));
        }
    }, [modalProps.inputFiles]);

    return (
        <MaterialModal
            title={"Job Details: " + modalProps.jobInfo ?? ""}
            isOpen={isOpen}
            onClose={hide}
            cancelButtonText="Close"
            id="job-details"
            maxWidth="sm"
            showPrimaryButton={false}
        >
            <div style={{ maxHeight: "60vh" }}>
                {modalProps.requestInfo && typeof modalProps.requestInfo != "undefined" ? (
                    <Paper>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        style={{ width: "25%", fontSize: 14, fontWeight: "bold", padding: "10px" }}
                                    >
                                        Client Name
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Client_Name}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                        Party ID
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Client_Key}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                        Client Code
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Client_Code}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                        Bill To Code
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Bill_To_Code}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                        Job Number
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Job_Number}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                        Step Type
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, padding: "10px" }}>
                                        {modalProps.requestInfo.Requestor_Domain == "AE"
                                            ? "FlowControl"
                                            : modalProps.requestInfo.Step_Code}
                                    </TableCell>
                                </TableRow>
                                {fileList.length > 0
                                    ? fileList.map((file, index) => (
                                          <TableRow key={`file-${index}`}>
                                              <TableCell style={{ fontSize: 14, fontWeight: "bold", padding: "10px" }}>
                                                  {index == 0 ? "Input Files" : ""}
                                              </TableCell>
                                              <TableCell style={{ fontSize: 14, padding: "10px" }}>{file}</TableCell>
                                          </TableRow>
                                      ))
                                    : null}
                            </TableBody>
                        </Table>
                    </Paper>
                ) : (
                    <div style={{ textAlign: "center" }}>
                        <span style={{ fontSize: 20 }}>Details Not Available</span>
                    </div>
                )}
            </div>
        </MaterialModal>
    );
};

export default withModal(JobDetailsModal, "FLOW_CONTROL_JOB_DETAILS");
